export default {
  retail: {
    breadcrumbHome: 'Startseite',
    breadcrumbSolutions: 'Lösungen',
    breadcrumbCurrent: 'Einzelhandel & Gastronomie',
    hero: {
      eyebrow: 'Einzelhandel & Gastronomie',
      title: 'Mehr Sicherheit in Laden und Gastronomie',
      lead: 'Eingang, Kassenzone, Lager und Küchenzugang – wir schützen Ihren Betrieb vor Diebstahl und Vandalismus, ohne Ihre Kunden zu stören.',
    },
    points: {
      title: 'Überwachungspunkte für Handel und Gastronomie',
      lead: 'Jedes Geschäft und jeder gastronomische Betrieb hat eigene Risikobereiche. Wir richten die Kameras genau dort ein, wo sie etwas bewirken.',
      items: {
        '0': { title: 'Eingang & Schaufenster', desc: 'Der erste Überwachungspunkt: Kameras am Eingang dokumentieren, wer kommt und geht – und schrecken schon beim Betreten ab.' },
        '1': { title: 'Kassenzone', desc: 'Kasse und Zahlungsbereich sind der sensibelste Punkt im Handel. Diskrete Kameras sichern den Bereich, ohne Kunden zu verunsichern.' },
        '2': { title: 'Verkaufsfläche', desc: 'Überblick über die gesamte Fläche: Weitwinkel-Kameras erkennen verdächtige Bewegungen in Regalbereichen und Nebenwegen.' },
        '3': { title: 'Lager & Anlieferung', desc: 'Warenannahme, Lager und Personalzugänge: Hier entstehen Lücken, wenn Ware an- oder abtransportiert wird. Wir schließen sie.' },
        '4': { title: 'Tresen & Küchenzugang', desc: 'In der Gastronomie sind Tresen und Küchenzugang kritische Bereiche. Robuste Kameras halten Feuchtigkeit und Wärme stand.' },
        '5': { title: 'Außenbestuhlung & Terrasse', desc: 'Terrasse und Außenbestuhlung sind Einladungen für Langfinger, besonders abends. Wetterfeste Kameras schauen zu.' },
      },
    },
    protection: {
      eyebrow: 'Diebstahlschutz',
      title: 'Weniger Inventurverlust, mehr Sicherheit',
      lead: 'Ladendiebstahl und Inventurdifferenzen kosten den Handel jedes Jahr erhebliche Summen. Richtig platzierte Kameras senken Verluste nachweislich – und liefern bei Bedarf belastbares Bildmaterial.',
      items: {
        '0': { title: 'Kassenzonen-Überwachung', desc: 'Scharfe Bilder von Kasse und Zahlungsbereich – für lückenlose Dokumentation bei Streitfällen und Manipulation.' },
        '1': { title: 'Schaufenster & Zugänge', desc: 'Abschreckung und Aufklärung bei Vandalismus oder Einbruch – vom Schaufenster bis zum Hintereingang.' },
        '2': { title: 'Ereignis-Protokolle', desc: 'Bewegung, Linienüberquerung oder Türereignisse lösen Aufzeichnung und Push-Meldung aus – genau wenn es relevant ist.' },
      },
    },
    gastro: {
      eyebrow: 'Gastronomie',
      title: 'Robuste Technik für Tresen, Küche und Terrasse',
      lead: 'Küchendampf, Fett und Feuchtigkeit stellen besondere Anforderungen an die Technik. Wir wählen Kameras, die im Gastronomie-Alltag zuverlässig arbeiten – und die Gäste nicht spüren.',
      list: {
        '0': 'Küchenzugang überwachen – nur berechtigtes Personal hat Zutritt',
        '1': 'Tresen- und Kassenbereich absichern, ohne Gäste zu stören',
        '2': 'Außenbestuhlung und Terrasse in den Abendstunden im Blick',
        '3': 'Lieferanten und Anlieferung lückenlos dokumentieren',
        '4': 'Hinweisschilder für Gäste und Personal anbringen',
      },
      note: 'Hinweis: Die rechtliche Zulässigkeit der Videoüberwachung hängt vom Einzelfall ab. Wir beraten Sie, ersetzen aber keine Rechtsberatung.',
    },
    cta: {
      title: 'Ihr Betrieb verdient einen sicheren Rahmen',
      lead: 'Wir zeigen Ihnen unverbindlich, wo sich Videoüberwachung für Sie rechnet – und wo sie nicht nötig ist.',
      primary: 'Beratungstermin vereinbaren',
      secondary: 'SSG Care entdecken',
    },
  },
};